export const CLIENT_SDK_VERSION = "2.18.0";
